import React, { useState, useRef } from 'react';
import { Alert, Typography } from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { ERROR_ALERT_TEXT } from '../constants';
import { scrollToBanner } from '../../utils/general';

export const orderStatusBanner = 'order-banner';

function BannerProvider({ children }) {
  const [showErrorAlert, setShowErrorAlert] = React.useState(false);
  const [errorAlertText, setErrorAlertText] = React.useState(ERROR_ALERT_TEXT);
  const [showOrderOrEReceiptSuccessAlert, setShowOrderOrEReceiptSuccessAlert] = React.useState(false);
  const [orderSuccessAlert, setOrderSuccessAlert] = React.useState([]);
  const scrollToAlert = useRef(null);

  React.useEffect(() => {
    if (scrollToAlert.current && (showOrderOrEReceiptSuccessAlert || showErrorAlert)) {
      scrollToBanner(scrollToAlert);
    }
  }, [showOrderOrEReceiptSuccessAlert, showErrorAlert]);

  function closeOrderStatusSuccessAlert(i) {
    if (orderSuccessAlert.length <= 1) {
      setShowOrderOrEReceiptSuccessAlert(false);
    } else {
      let newArray = orderSuccessAlert.filter((item) => item !== orderSuccessAlert[i]);
      setOrderSuccessAlert(newArray);
    }
  }

  function openErrorAlert(text) {
    setErrorAlertText(text || ERROR_ALERT_TEXT);
    setShowErrorAlert(true);
    setShowOrderOrEReceiptSuccessAlert(false);
  }

  function openOrderOrEReceiptSuccessAlert(successBanners) {
    setOrderSuccessAlert(successBanners);
    setShowOrderOrEReceiptSuccessAlert(true);
    setShowErrorAlert(false);
  }

  function orderOrEReceiptSuccessAlertBanner() {
    // eslint-disable-next-line no-lone-blocks
    return (showOrderOrEReceiptSuccessAlert && (
      <div ref={scrollToAlert}>

        {[...orderSuccessAlert].map((alert, index) => (
          <Alert
            key={index}
            aria-label={orderStatusBanner}
            onClose={() => closeOrderStatusSuccessAlert(index)}
            status="success"
            size="large"
          >
            <Typography>{alert}</Typography>
          </Alert>
        )
        )}
      </div>
    ));
  }

  function errorAlert() {
    return (showErrorAlert && (
      <div ref={scrollToAlert}>
        <Alert ref={scrollToAlert} status="error" size="large">
          <Typography>{errorAlertText}</Typography>
        </Alert>
      </div>
    ));
  }

  return (
    <OrderBannerContext.Provider
      value={{
        openErrorAlert,
        openOrderOrEReceiptSuccessAlert,
        closeOrderStatusSuccessAlert,
      }}
    >
      <div>
        {orderOrEReceiptSuccessAlertBanner()}
        {errorAlert()}
        {children}
      </div>
    </OrderBannerContext.Provider>
  );
}

const OrderBannerContext = React.createContext(null);

export { OrderBannerContext, BannerProvider };

BannerProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
};
